import * as React from 'react';
import './AssetThumbnail.scss';

export type AssetThumbnailProps = React.HTMLAttributes<any> & {
    children?: React.ReactNode;
};

export const AssetThumbnail = React.forwardRef<HTMLDivElement, AssetThumbnailProps>(
    ({ children, className, ...props }, ref) => (
        <div ref={ref} {...props} className={`Thumbnail ${className ?? ''}`}>
            {children}
        </div>
    ),
);
AssetThumbnail.displayName = 'AssetThumbnail';

export const AssetThumbnailTitle: React.FunctionComponent<{ children?: React.ReactNode }> = ({ children }) => (
    <div className="Thumbnail__title">{children}</div>
);
AssetThumbnailTitle.displayName = 'AssetThumbnailTitle';

export const AssetThumbnailContent: React.FunctionComponent<{ children?: React.ReactNode }> = ({ children }) => (
    <div className="Thumbnail__content">{children}</div>
);
AssetThumbnailContent.displayName = 'AssetThumbnailContent';

export const AssetThumbnailToolbar: React.FunctionComponent<{ children?: React.ReactNode }> = ({ children }) => (
    <div className="Thumbnail__toolbar">{children}</div>
);
AssetThumbnailToolbar.displayName = 'AssetThumbnailToolbar';
